import { styled } from 'goober';
import { route } from 'preact-router';
import EditIcon from '../../assets/checkoutWidget/edit-icon.svg';
import Style from './style.css';
import { currencyFormat } from '../directives/currencyFormat';
import { useCheckoutContext, useCheckoutDispatchContext } from '../../storeProviders/checkoutWidgetStore';
import { checkEligibilityRoute } from '../../alias/checkoutWidgetRoutes';

const Container = styled('div')`
  width: 100%;
  padding: 20px 10px 10px;
  background-color: #ffffff;
  margin-bottom: 15px;
  border-bottom: 1px solid #d3d8e5;
  position: sticky;
  top: 0;
  z-index: 2;
  .borderLeft {
    border-left: 1px solid #d3d8e5;
    padding-left: 10px;
    min-width: 50%;
  }
`;

const TitleText = styled('div')`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #636363;
  margin-left: 6px;
`;

const MainDiv = styled('div')`
  justify-content: space-between;
  flex-wrap: nowrap;
`;

const Details = styled('div')`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #003c7c;
  margin-left: 6px;
  display: flex;
`;

const Icon = styled('div')`
  margin: 5px;
  width: 24px;
  height: 27px;
  background-color: #003c7c;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  border-radius: 4px;
  font-weight: bold;
`;

export default function UserDetailsHeader() {
  const checkoutState = useCheckoutContext();
  return (
    <Container>
      <MainDiv className={Style.flexRow}>
        <div className={Style.flexRow}>
          <Icon>₹</Icon>
          <div className={Style.flexColumn}>
            <TitleText>Amount</TitleText>
            <Details>{currencyFormat(checkoutState.amount)}</Details>
          </div>
        </div>
        {checkoutState.userDetailsConfig.showMobileContainer && (
          <div className={`${Style.flexRow} borderLeft`}>
            <Icon>
              <span class='material-icons'>person</span>
            </Icon>
            <div className={Style.flexColumn}>
              <TitleText>Mobile</TitleText>
              <Details>
                {checkoutState.mobileNo}{' '}
                {checkoutState.userDetailsConfig.showEditIcon && (
                  <div style={{ margin: 'auto 15px', cursor: 'pointer' }}>
                    <img onClick={()=>{route(checkEligibilityRoute.path);}} src={EditIcon} />
                  </div>
                )}
              </Details>
            </div>
          </div>
        )}
      </MainDiv>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./components/checkoutWidget/UserDetailsHeader.js